export enum ModelType {
  MIKE21 = 'MIKE 21',
  MIKE3 = 'MIKE 3',
  MIKE21SW = 'MIKE 21 SW',
}
